(() => {
  const normalizeHeadings = () => {
    if (!document.body.classList.contains('lcd-sleep-tech')) return;
    document.querySelectorAll('#MainContent .shopify-policy__body p, #MainContent[data-template^="page"] :is(.page-content, .rte) p').forEach((paragraph) => {
      const strong = paragraph.firstElementChild;
      if (paragraph.childElementCount !== 1 || strong?.tagName !== 'STRONG' || !strong.textContent.trim()) return;
      if (!/^\d+[.)]\s/.test(strong.textContent.trim())) return;
      const hasOtherContent = [...paragraph.childNodes].some((node) => node !== strong && node.nodeType !== Node.COMMENT_NODE && (node.nodeType !== Node.TEXT_NODE || node.textContent.trim()));
      if (hasOtherContent) return;
      paragraph.classList.add('lcd-type-content-heading');
      paragraph.setAttribute('role', 'heading');
      paragraph.setAttribute('aria-level', '2');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeHeadings, { once: true });
  else normalizeHeadings();
  document.addEventListener('shopify:section:load', normalizeHeadings);
})();
